import FilterConstants from '../filter-constants';
import { numberToUserDisplay, userEntryToNumber } from '@ebiz/pretty-num';

export function padLeft(strtopad, num, padchar) {
  // Pads Characters given the length num with character padchar
  return strtopad.length < num ? Array(num - String(strtopad).length + 1).join(padchar || '0') + strtopad : strtopad;
}

export function truncateValue(numVal, significantDigits) {
  let stringVal = parseInt(numVal).toString();
  if (stringVal.length > significantDigits) {
    let stringArr = stringVal.split('');
    for (let i = significantDigits; i < stringArr.length; i++) {
      stringArr[i] = '0';
    }
    stringVal = stringArr.join('');
  }
  return parseFloat(stringVal);
}

export function toFixedClean(value, precisionIn) {
  let precision = precisionIn || 0,
    power = Math.pow(10, precision),
    absValue = Math.abs(Math.round(value * power)),
    result = (value < 0 ? '-' : '') + String(Math.floor(absValue / power));

  if (precision > 0) {
    let fraction = String(absValue % power),
      padding = new Array(Math.max(precision - fraction.length, 0) + 1).join('0');
    result += '.' + padding + fraction;
  }
  return result;
}

export function isEngineeringFormated(value) {
  return value !== null && value !== undefined && value.toString().match(/[afpnuµmkMGT]$/g);
}

export function capitalizeFirstLetter(stringVal) {
  return stringVal.charAt(0).toUpperCase() + stringVal.slice(1);
}

export function uncapitalizeFirstLetter(stringVal) {
  return stringVal.charAt(0).toLowerCase() + stringVal.slice(1);
}

export function applyValueTolerance(rawVal, roundedVal) {
  let tolerance = 0.00000000000001;
  return Math.abs(rawVal - roundedVal) < tolerance ? roundedVal : rawVal;
}

// This function formats a raw number value into a display value depending upon type.
// Input: value - value to be formatted
//        fieldType - type of field (from FilterConstants.fieldTypes)
//        param - extra parameters
// Returns: result - formatted value
export function formatFieldValue(value, fieldType, param) {
  let result = '';
  switch (fieldType) {
    case FilterConstants.fieldTypes.AllChars:
    case FilterConstants.fieldTypes.Alphabet:
    case FilterConstants.fieldTypes.AlphaNumeric: {
      switch (param) {
        case FilterConstants.fieldCapitlization.UpperCase:
          result = value.toUpperCase();
          break;
        case FilterConstants.fieldCapitlization.LowerCase:
          result = value.toLowerCase();
          break;
        case FilterConstants.fieldCapitlization.FirstChar:
          result = this.capitalizeFirstLetter(value);
          break;
        default:
          break;
      }
      break;
    }
    case FilterConstants.fieldTypes.Numeric:
      result = Number(value).toString();
      break;
    case FilterConstants.fieldTypes.NumericDecimal: {
      let hasTrailingZeroes = param[param.length - 1] === 'z';
      let trimmedParam = param;
      if (hasTrailingZeroes) {
        trimmedParam = param.substring(0, param.length - 1);
      }
      let digitVal = Number(trimmedParam.substring(0, trimmedParam.length - 1));
      let digitType = trimmedParam.substring(trimmedParam.length - 1, trimmedParam.length);
      let rawValue = Number(value);
      result = numberToUserDisplay(rawValue, 'Standard', digitVal, {
        fixedDigits: digitType === 'd',
        showZeroes: hasTrailingZeroes,
      });
      break;
    }
    case FilterConstants.fieldTypes.Custom:
      break;
    case FilterConstants.fieldTypes.Engineering: {
      let patterninf = /^inf/i;
      let patternNeginf = /^-inf/i;
      let hasTrailingZeroes = param[param.length - 1] === 'z';
      let trimmedParam = param;
      if (hasTrailingZeroes) {
        trimmedParam = param.substring(0, param.length - 1);
      }
      let digitVal = Number(trimmedParam.substring(0, trimmedParam.length - 1));
      let digitType = trimmedParam.substring(trimmedParam.length - 1, trimmedParam.length);
      let rawValue = isEngineeringFormated(value) ? userEntryToNumber(value) : value;
      let engResult = numberToUserDisplay(rawValue, 'Engineering', digitVal, {
        fixedDigits: digitType === 'd',
        showZeroes: hasTrailingZeroes,
      });
      result = engResult.match(patterninf) || engResult.match(patternNeginf) ? value.toString() : engResult;
      break;
    }
    default:
      break;
  }
  return result;
}

export function sigFigsDown(n, sig) {
  const mult = Math.pow(10, sig - Math.floor(Math.log10(n)) - 1);
  return Math.trunc(n * mult) / mult;
}
